import { Ticket } from "../../models/Ticket";
import {
  TICKETS_BOUGHT_2_COLUMNS_THRESHOLD,
  TICKETS_BOUGHT_3_COLUMNS_THRESHOLD,
} from "../../utils/Constants";
import Button from "../miscellaneous/Button";
import { ButtonTheme } from "../miscellaneous/ButtonTheme";
import TicketEntry from "../miscellaneous/TicketEntry";
import Dialog from "./components/Dialog";

export interface TicketsBoughtDialogProps {
  onClose: () => void;
  drawDate: Date | undefined;
  ticketsBought: Ticket[];
}

export default function TicketsBoughtDialog(props: TicketsBoughtDialogProps) {
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
  };
  const formattedDate: string | undefined = props.drawDate?.toLocaleDateString(
    undefined,
    options,
  );
  const cols =
    props.ticketsBought.length > TICKETS_BOUGHT_3_COLUMNS_THRESHOLD
      ? 3
      : props.ticketsBought.length > TICKETS_BOUGHT_2_COLUMNS_THRESHOLD
        ? 2
        : 1;
  return (
    <Dialog onClose={props.onClose}>
      <div className="flex flex-col items-center ~px-10/8">
        <span className="flex text-center ~text-lg/xxl ~leading-5/6 font-barlowc font-bold text-silver ~mb-6/8">
          YOUR PURCHASED TICKETS
          <br />
          FOR {formattedDate?.toUpperCase() ?? "..."}
        </span>
        <div className={`grid grid-cols-${cols} ~gap-x-1.5/3`}>
          {props.ticketsBought.map((ticket: Ticket, index: number) => (
            <div className="~p-1/1.5 my-1.5 bg-bastille rounded-md" key={index}>
              <TicketEntry key={index} ticket={ticket}></TicketEntry>
            </div>
          ))}
        </div>
        <div className="~mt-6/8">
          <Button
            text={"CLOSE"}
            enabled={true}
            loading={false}
            theme={ButtonTheme.PersianPink}
            onClick={props.onClose}
          ></Button>
        </div>
      </div>
    </Dialog>
  );
}
